import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { ConfirmPage } from "@nju/feature-portal-reset-password";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function ResetPasswordConfirmation() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent spacing="xxl">
        <ConfirmPage />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
